import { MIME_TYPE_FORM_DATA_MULTIPART } from "@rumble-it/common-lib/src/constants/mimeTypes";
import { axiosInstance } from "../client";
import { Media } from "@rumble-it/common-lib/types/models/Media.interface";

export const uploadMedia = async (
  file: File,
  onProgress?: (percent: number) => void,
): Promise<Media> => {
  const formData = new FormData();
  formData.append("file", file);

  return axiosInstance
    .post(`/media`, formData, {
      headers: { "Content-Type": MIME_TYPE_FORM_DATA_MULTIPART },
      onUploadProgress: (event) => {
        if (!event.total || !onProgress) return;
        const percentCompleted = Math.round((event.loaded / event.total) * 100);
        onProgress?.(percentCompleted);
      },
    })
    .then((response) => response.data);
};
